<!-- 通知公告Notice -->
<template>
    <div>
        <!--封禁弹窗-->
        <el-dialog title="企业已封禁" :visible.sync="entBanDialog" width="500px" append-to-body>
            <span>抱歉，所属的企业因违规操作已被封禁，您无法进入企业中心</span><br>
            <span>如需帮助，请致电：400-684-0020</span>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="entBanDialog = false">确 定</el-button>
                <el-button @click="entBanDialog = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="系统提示" :visible.sync="authRejectDialog" width="500px" append-to-body>
            <span>企业认证未通过，如需认证请再次提交认证信息！</span><br>
            <span>如需帮助，请致电：400-684-0020</span>
            <div slot="footer" class="dialog-footer">
                <el-button @click="authRejectDialog = false">取 消</el-button>
                <el-button @click="gotoAuthentication">前往认证</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {checkUserAndEnt, getInfoById} from '@/api/enterprise'
    import {checkSysManage, getEnterpriseAdmin, getLoginUserInfo, logout} from '@/api/user'

    export default {
        name: 'EntCheckDialog',
        data() {
            return {
                entBanDialog: false,
                authRejectDialog: false,
                loginUri: '/login',
                enterpriseId: undefined,
            }
        },
        computed: {
            check() {
                return this.$store.state.index.entCheckDialog.check;
            },
            uri() {
                return this.$store.state.index.entCheckDialog.targetUri;
            }
        },
        watch: {
            check(newVal, oldVal) {
                if (newVal) {
                    this.$store.commit('gotoEnterprise', {
                        check: false,
                        targetUri: this.uri
                    });
                    this.gotoEnterprise();
                }
            },
        },
        methods: {
            gotoAuthentication() {
                if (process.env.NODE_ENV == "development") {
                    window.open(window.location.origin + '/frontend#/authentication');
                } else {
                    window.open(window.location.origin + '/#/authentication');
                }
                this.authRejectDialog = false;
            },
            gotoEnterprise() {
                if (!this.Cookies.get("TipDM-Login-Token")) {
                    // 跳转到登录页面
                    window.location.href = this.loginUri;
                    return
                }
                checkUserAndEnt().then(res => {
                    if (res.status == 200) {
                        let enterpriseId = res.data.enterpriseId;
                        let status = res.data.status
                        if (status == 'NO_LOGIN') {
                            // 跳转到登录页面
                            window.location.href = this.loginUri;
                        } else if (status == 'NO_AUTH') { // 没有提交认证

                            this.gotoAuthentication();
                            return
                        } else if (status == 'NO_DISPOSE') {// 认证未处理

                            // 前置条件3：已登录账号，并且已提交企业认证信息，未有审核结果
                            // 当前页面顶部居中显示悬浮提示，3秒后消失，提示文案：企业认证审核中，待审核通过后即可进入企业中心，请耐心等待
                            this.msgSuccess("企业认证审核中，待审核通过后即可进入企业中心，请耐心等待！")
                            return
                        } else if (status == 'AUTH_REJECT') {// 认证被拒绝
                            // 前置条件4：已登录账号，并且已提交企业认证，审核未通过
                            // 当前页面顶部居中显示悬浮提示，3秒后消失，提示文案：企业认证未通过，如需认证请再次提交认证信息
                            // this.msgSuccess("企业认证未通过，如需认证请再次提交认证信息！")
                            this.authRejectDialog = true;
                        } else if (status == 'BAN') {// 企业被封禁
                            this.entBanDialog = true
                            return

                        } else if (enterpriseId && status == 'NORMAL') {// 正常

                            // 更新企业id
                            window.localStorage.setItem('enterpriseId', enterpriseId);

                            if (this.uri) {
                                console.log('跳转到：' + this.uri)
                                window.open(window.location.origin + this.uri);
                            } else {
                                window.open(window.location.origin + "/backend#/index");
                            }
                        } else {
                            this.$message.error("查询数据失败！");
                            console.log('数据异常！')
                        }
                    } else {
                        this.$message.error("查询数据失败！");
                    }
                }).catch(() => {
                    this.$message.error("查询数据失败！");
                })
            }

            // /** 进入企业中心*/
            // gotoEnterprise(){
            //     this.userId = window.localStorage.getItem('userId');
            //     this.enterpriseId = window.localStorage.getItem('enterpriseId');
            //
            //     // 前置条件1：未登录账号
            //     if(!this.userId){
            //         console.log('没有用户，跳转到登录页')
            //         // 跳转到登录页面
            //         window.location.href = this.loginUri;
            //     }
            //
            //     // 有企业id (企业id从企业-管理员表中查出来)
            //     if(this.enterpriseId){
            //
            //         console.log('查询企业信息')
            //         // 查询企业信息
            //         getInfoById(this.enterpriseId).then(res => {
            //             // 查询企业数据失败
            //             if(!res || res.status != 200){
            //                 this.msgError("企业数据查询失败，请与管理员联系！")
            //                 return
            //             }
            //
            //             let enterpriseInfo = res.data
            //             // 正常、变更
            //             // 前置条件5：已登录并且已完成认证，认证审核通过，点击发布职位按钮，新标签页打开企业中心-发布职位页面
            //             if(enterpriseInfo.status === 'NORMAL' || enterpriseInfo.status === 'UPDATE'){
            //                 window.open(window.location.origin + "/backend#/job");
            //                 return
            //             }
            //
            //             // 被封禁
            //             if(enterpriseInfo.status == 'BAN'){
            //                 this.entBanDialog = true
            //                 return
            //             }
            //
            //             // 不正常
            //             getLastAuthenticationByCondition(this.enterpriseId,{}).then(res => {
            //                 let authentication = res.data;
            //                 // 前置条件2：已登录账号，未进行企业认证，点击发布招聘按钮,新标签页打开企业认证页面
            //                 if(!authentication){
            //                     this.$router.push({path: `/authentication`});
            //                     return
            //                 }
            //
            //                 if(authentication.status == 'UNDISPOSE'){
            //                     // 前置条件3：已登录账号，并且已提交企业认证信息，未有审核结果
            //                     // 当前页面顶部居中显示悬浮提示，3秒后消失，提示文案：企业认证审核中，待审核通过后即可进入企业中心，请耐心等待
            //                     this.msgError("企业认证审核中，待审核通过后即可进入企业中心，请耐心等待！")
            //                 }else if(authentication.status == 'DISPOSE'){
            //                     // 前置条件4：已登录账号，并且已提交企业认证，审核未通过
            //                     // 当前页面顶部居中显示悬浮提示，3秒后消失，提示文案：企业认证未通过，如需认证请再次提交认证信息
            //                     this.msgError("企业认证未通过，如需认证请再次提交认证信息！")
            //                 }
            //             });
            //         });
            //     }else{
            //         // 没有企业id也可能是没有认证过(企业id从企业-管理员表中查出来)
            //
            //
            //         console.log('没有企业id也可能是没有认证过')
            //         this.$router.push({path: `/authentication`});
            //         return
            //     }
            // },
        }
    }
</script>
